export class HealthConnectNotImplementedException extends Error {
    constructor(message?: string, options?: ErrorOptions) {
        super(message ?? 'Health Connect is not implemented', options);
    }
}
